import { useLocation } from "react-router-dom";

const useQueryParam = (param: string) => {
    const location = useLocation();
    const searchString = new URLSearchParams(location.search);
    return searchString.get(param) as string;
};

export default useQueryParam;
